import React from 'react';

import styles from './style.scss';


const TrialCardBillingInfo = ({ imageStyleName, children }) => (
  <div className={styles.billingInfo}>
    {imageStyleName && (
      <i className={imageStyleName} />
    )}
    <div className={styles.billingInfoTitle}>
      {children}
    </div>
  </div>
);

export default TrialCardBillingInfo;
